module.exports = __webpack_public_path__ + "static/media/pressureblower.762f2f44.png";